import React, { useState, useEffect } from 'react';
import axios from 'axios';

function Dashboard() {
  const [stats, setStats] = useState({
    totalProducts: 0,
    totalCustomers: 0,
    totalOrders: 0,
    totalRevenue: 0
  });
  const [recentOrders, setRecentOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchDashboardData();
  }, []);

  const fetchDashboardData = async () => {
    try {
      setLoading(true);
      const [products, customers, orders] = await Promise.all([
        axios.get('/api/products'),
        axios.get('/api/customers'),
        axios.get('/api/orders')
      ]);

      const totalRevenue = orders.data.reduce((sum, order) => sum + order.total_amount, 0);
      const recent = orders.data.slice(0, 5);

      setStats({
        totalProducts: products.data.length,
        totalCustomers: customers.data.length,
        totalOrders: orders.data.length,
        totalRevenue: totalRevenue
      });

      setRecentOrders(recent);
    } catch (error) {
      console.error('Error fetching dashboard data:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="loading">Đang tải dữ liệu...</div>;
  }

  return (
    <div>
      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-label">Sản phẩm</div>
          <div className="stat-value">{stats.totalProducts}</div>
        </div>
        <div className="stat-card">
          <div className="stat-label">Khách hàng</div>
          <div className="stat-value">{stats.totalCustomers}</div>
        </div>
        <div className="stat-card">
          <div className="stat-label">Hóa đơn</div>
          <div className="stat-value">{stats.totalOrders}</div>
        </div>
        <div className="stat-card">
          <div className="stat-label">Doanh thu</div>
          <div className="stat-value">{stats.totalRevenue.toLocaleString()} ₫</div>
        </div>
      </div>

      <div className="card">
        <h3 className="card-title">Hóa đơn gần đây</h3>
        {recentOrders.length === 0 ? (
          <div className="empty-state">Chưa có hóa đơn nào</div>
        ) : (
          <table>
            <thead>
              <tr>
                <th>ID</th>
                <th>Khách hàng</th>
                <th>Loại</th>
                <th>Tổng tiền</th>
                <th>Ngày</th>
              </tr>
            </thead>
            <tbody>
              {recentOrders.map(order => (
                <tr key={order.id}>
                  <td>#{order.id}</td>
                  <td>{order.customer_name}</td>
                  <td>{order.order_type === 'wholesale' ? 'Bán sỉ' : 'Bán lẻ'}</td>
                  <td>{order.total_amount.toLocaleString()} ₫</td>
                  <td>{new Date(order.created_at).toLocaleDateString('vi-VN')}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

export default Dashboard;
